import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { Response, VehicleType, VehicleTypeSearchRequest } from '@core/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehicleTypeService {
  constructor(private http: HttpClient) { }

  search(request: VehicleTypeSearchRequest): Observable<Response<VehicleType[]>> {
    return this.http.post<Response<VehicleType[]>>(environment.apiUrl + '/api/VehicleType/Search', request);
  }
}
